import { toast } from 'react-toastify';
import { all, call, put, takeLatest } from 'redux-saga/effects'

import ApiPath from '../../../constants/apiPath';
import { ApiClient } from '../../../utilities/api';
import { setGetCompanyInformation, onErrorStopLoad, setCreateEndrosement, setGetUpdatedCompanyInformation } from '../../slices/companyInformation';


function* CompanyInformation(action) {
  try {
    const resp = yield call(ApiClient.get, action.url = `${ApiPath.CompanyInformationApiPath.COMPANY_INFORMATION}${action.payload.id}`);
    if (resp.status) {
      yield put(setGetCompanyInformation(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setGetCompanyInformation({}));
    yield put(onErrorStopLoad())
    // toast.error(e.response.data.msg);
  }
}
function* getUpdatedCompanyInformation(action) {
  try {
    const resp = yield call(ApiClient.get, action.url = `${ApiPath.CompanyInformationApiPath.COMPANY_INFORMATION}${action.payload.id}`);
    if (resp.status) {
      yield put(setGetUpdatedCompanyInformation(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setGetUpdatedCompanyInformation({}));
    yield put(onErrorStopLoad())
    // toast.error(e.response.data.msg);
  }
}

function* CreateEndrosements(action) {
  try {
    const resp = yield call(ApiClient.post, action.url = ApiPath.CompanyInformationApiPath.CREATE_ENDROSEMENT, action.payload = action.payload);
    if (resp.status) {
      yield put(setCreateEndrosement(resp.data.payload));
      yield call(action.payload.cb, action.res = resp)
      // toast.success(action.res.data.msg);
    }
    else {
      throw resp
    }
  } catch (e) {
    yield put(setCreateEndrosement({}));
    yield put(onErrorStopLoad())
    toast.error(e.response.data.msg);
  }
}



function* userOpportunity() {
  yield all([
    takeLatest('companyInformation/getCompanyInformation', CompanyInformation),
    takeLatest('companyInformation/getUpdatedCompanyInformation', getUpdatedCompanyInformation),
    takeLatest('companyInformation/createEndrosement', CreateEndrosements),

  ])
}

export default userOpportunity;